export default {
  app_preloaded: false,
  is_configurator_fetched: false,
  is_configurator_selected: false,
  is_configurator_undefined: true,
  configurations: [],
  configurator: {},
  configurator_overlay: false,
  social: {},
  social_title: '',
  type: '',
};
